import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { HttpInternalService } from "./http.service";
import { AppConfigService } from "src/app/appConfig.service";

@Injectable({
  providedIn: 'root'
})
export class CustomFieldService {

  private get baseUrl(): string {
    return this.configService.apiURL;
  }

  constructor(private http: HttpClient,  private _httpService: HttpInternalService, private configService: AppConfigService) { }

  CreateCustomField(userObj:any) {
    return this.http.post<any>(`${this.baseUrl}/CustomField/CreateCustomField`, userObj);
  }

  GetAllCustomFields(userObj:any): Observable<any> {
    return this._httpService.getRequest<any>('CustomField/GetAllCustomFields?organizationId=' + userObj.Organization_ID);
  }

  DeleteCustomField(userObj:any) {
    return this.http.post<any>(`${this.baseUrl}/CustomField/DeleteCustomField`, userObj);
  }

  GetCustomField(userObj:any) {
    return this.http.get<any>(`${this.baseUrl}/CustomField/GetCustomField?organizationId=${userObj.organization_Id}&id=${userObj.custom_field_id}`);
  }

  FieldActivationOrDeletion(id: string, status: boolean) {
    return this.http.get<any>(`${this.baseUrl}/CustomField/UpdateFieldStatus?id=${id}&IsActive=${status}`);
  }

  // Mock form methods
  GetAllForms(organizationId: string): Observable<any> {
    return this._httpService.getRequest<any>('CustomField/GetAllCustomForms?organizationId=' + organizationId);
  }

  CreateForm(formData: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/CustomField/CreateCustomForm`, formData);
  }


  GetForm(formId: number) {
    return this.http.get(`${this.baseUrl}/CustomField/GetForm/${formId}`);
  }

  DeleteForm(formId: number) {
    return this.http.delete(`${this.baseUrl}/CustomField/DeleteForm/${formId}`);
  }

  // Add method for saving field order
  SaveFieldsOrder(orderData: any) {
    return this.http.put(`${this.baseUrl}/CustomField/SaveFieldsOrder`, orderData);
  }

  // Optional: Method to get fields by form
  GetFieldsByForm(formId: number, organizationId: string) {
    return this.http.get(`${this.baseUrl}/CustomField/GetFieldsByForm?organizationId=${organizationId}&formId=${formId}`);
  }

    // Optional: Method to get fields by form
    GetAllInvoiceRelatedData(taskId: string, organizationId: string) {
      return this.http.get(`${this.baseUrl}/CustomField/GetAllInvoiceRelatedData?organizationId=${organizationId}&taskId=${taskId}`);
    }

  CreateFormFieldValues(formData: any) {
    return this.http.post<any>(`${this.baseUrl}/Invoices/InsertFormValuesForInvoice`, formData);
  }
}
